import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useQuery } from '@apollo/client'
import { useAuth } from '@praxis/component-auth'
import { userSessionTokenQuery } from '../../graphql/userSession'
import { setUserProfile, setUserSession } from '../../store/userProfile'
import { getUserInfo } from '../../resources/commonUtills'

export const useMain = () => {
  const dispatch = useDispatch()
  const auth = useAuth()
  const { session } = auth
  const { loading, error, data } = useQuery(userSessionTokenQuery())

  const getUserProfile = useSelector((state) => {
    return getUserInfo(state)
  })
  useEffect(() => {
    dispatch(setUserProfile(data?.userSessionToken?.token))
    if (session) {
      dispatch(setUserSession(session))
    }
  }, [data, dispatch, session])

  return {
    loading,
    error,
    data,
    getUserProfile,
  }
}
